module.exports = __webpack_public_path__ + "img/2.15b2a6a0.png";